export const CloseModalIcon = ({ color = 'white' }) => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.500244" width="35" height="35" rx="17.5" stroke={color} />
    <path
      d="M24.2501 11.4502L11 24.7003M11 11.4502L24.2501 24.7003"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
